/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  SuccessType,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface EnableCertificationInput {
  emailCert: string;
  cod_installatore: number;
}
const build = (_query: DocumentNode, input: EnableCertificationInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.emailCert !== undefined ? `$emailCert: String = ${JSON.stringify(input.emailCert).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.cod_installatore !== undefined ? `$cod_installatore: Int = ${JSON.stringify(input.cod_installatore).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    enableCertification(
      ${ input.emailCert !== undefined ? 'emailCert: $emailCert,' : '' } 
      ${ input.cod_installatore !== undefined ? 'cod_installatore: $cod_installatore,' : '' }
    ){
      ...successtype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class EnableCertificationMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment successtype on SuccessType { ... }
   */
  async execute(_query: DocumentNode, input: EnableCertificationInput): Promise<apollo.FetchResult< { enableCertification: Partial<SuccessType> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ enableCertification: Partial<SuccessType> }>({ mutation: build(_query, input) });
  }
}
